import { useMutation, useQueryClient } from '@tanstack/react-query'
import { useActions } from '../../store'
import { useErrorHandler } from '../useErrorHandler'
import { useResponseHandler } from '../useResponseHandler'
import { useAuth } from '../'

const { env } = window

const useSaveStoryMutation = () => {
  const { securedFetch } = useAuth()
  const { handleError } = useErrorHandler()
  const { handleResponse } = useResponseHandler()
  const { setMessage, progressStart, progressEnd } = useActions()
  const queryClient = useQueryClient()

  const saveStory = async (categoryId, storyId, title, content) => {
    const url = encodeURI(
      storyId
        ? `${env.apiUrl}/stories/${storyId}`
        : `${env.apiUrl}/categories/${categoryId}/stories`
    )
    const response = await securedFetch(url, {
      method: storyId ? 'PUT' : 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ title, content })
    })
    await handleResponse(response)
    return response.json()
  }

  return useMutation({
    mutationFn: ({ categoryId, storyId, title, content }) =>
      saveStory(categoryId, storyId, title, content),
    onMutate: progressStart,
    onError: (error) => handleError(error, 'Error publishing story'),
    onSuccess: (data, variables) => {
      setMessage('Story was published')
      if (!variables.storyId) {
        queryClient.setQueryData(
          ['stories', variables.categoryId],
          (stories) => [...stories, data]
        )
      }
      queryClient.invalidateQueries(['stories', variables.categoryId])
    },
    onSettled: progressEnd
  })
}

export { useSaveStoryMutation }
